import api from './api';

// Lists API
export const listsService = {
  getAll: () => api.get('/lists'),
  create: (data) => api.post('/lists', data),
  update: (id, data) => api.put(`/lists/${id}`, data),
  delete: (id) => api.delete(`/lists/${id}`),
};

// Tasks API
export const tasksService = {
  getAll: (listId = null) => {
    const params = listId ? { list_id: listId } : {};
    return api.get('/tasks', { params });
  },
  create: (data) => api.post('/tasks', data),
  update: (id, data) => api.put(`/tasks/${id}`, data),
  delete: (id) => api.delete(`/tasks/${id}`),
  toggle: (id) => api.post(`/tasks/${id}/toggle`),
  
  // Subtasks
  addSubtask: (taskId, title) => api.post(`/tasks/${taskId}/subtasks`, { title }),
  toggleSubtask: (taskId, subtaskId) => api.post(`/tasks/${taskId}/subtasks/${subtaskId}/toggle`),
  deleteSubtask: (taskId, subtaskId) => api.delete(`/tasks/${taskId}/subtasks/${subtaskId}`),
};

// Tags API
export const tagsService = {
  getAll: () => api.get('/tags'),
};
